import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { AppClientConfigurationService } from '@sdbn/common';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { StationSelectionLevel } from '../../../../components/station-selection/model/StationSelectionLevel.enum';
import { StructureSelection } from '../../../../common/structure-selection/structure-selection.model';
import { TransportScope } from '../../../../common/model/transport.model';

@Component({
    selector: 'app-detach-trailer-semi-trailer-truck',
    templateUrl: './detach-trailer-semi-trailer-truck.component.html',
    styleUrls: ['./detach-trailer-semi-trailer-truck.component.scss'],
    standalone: false
})
export class DetachTrailerSemiTrailerTruckComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  requiredSelectionLevels: StationSelectionLevel[] = [StationSelectionLevel.STATION];

  TransportScope = TransportScope;

  formGroup = new FormGroup({
    transportScope: new FormControl(null, Validators.required),
    cargo: new FormControl(null),
    orderReference: new FormControl(null),
    trailerNumberPlate: new FormControl(null),
    trailerIdentifier: new FormControl(null),
    swapTrailerNumber: new FormControl(null)
  });

  constructor(
    private configurationService: AppClientConfigurationService,
    private stepperService: TransportAttachDetachStepperService
  ) {
    this.stepperModel = this.stepperService.stepperModel;
    this.stepperModel.workingData.targetTransportScope = TransportScope.TRAILER;

    this.updateForm();

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      if (!this.formGroup) {
        return false;
      }
      return this.formGroup.valid && this.stepperModel.workingData.targetStationId != null;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
    this.formGroup.valueChanges.subscribe(values => {
      this.stepperModel.workingData.cargo = values.cargo;
      this.stepperModel.workingData.orderReference = values.orderReference;
      this.stepperModel.workingData.targetTransportScope = values.transportScope;
      this.stepperModel.workingData.trailerNumberPlate = values.trailerNumberPlate;
      this.stepperModel.workingData.trailerIdentifier = values.trailerIdentifier;
      this.stepperModel.workingData.swapTrailerNumber = values.swapTrailerNumber;
    });

  }

  onStationSelectionChanged(selection: StructureSelection) {
    this.stepperModel.workingData.targetStationId = selection.stationId;
  }

  swapTrailerEnabled() {
    return this.configurationService.isPropertyTrue(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

  targetScopeSwapTrailerSelected() {
    return this.stepperModel.workingData.targetTransportScope === TransportScope.SWAP_TRAILER;
  }

  targetScopeTrailerSelected(): any {
    return this.stepperModel.workingData.targetTransportScope === TransportScope.TRAILER;
  }

  private updateForm() {
    this.formGroup.patchValue({
      transportScope: this.stepperModel.workingData.targetTransportScope,
      cargo: this.stepperModel.workingData.cargo,
      orderReference: this.stepperModel.workingData.orderReference,
      trailerNumberPlate: this.stepperModel.workingData.trailerNumberPlate,
      trailerIdentifier: this.stepperModel.workingData.trailerIdentifier,
      swapTrailerNumber: this.stepperModel.workingData.swapTrailerNumber
    });
  }
}
